<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        rounded
        v-on="on"
        v-bind="attrs"
        class="float-right"
        color="teal"
        >Outros valores de frete</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Outros valores de frete </v-card-title>
      <v-card-text>
        <v-data-table
          :items="novopedido.cliente.outrosfretes"
          :headers="headers"
          disable-sort
          hide-default-footer
          no-data-text="Nenhum outro valor de frete"
        >
          <template v-slot:[`item.valor`]="{ item }">
            {{ formatarMoeda(item.valor) }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatMoeda } from "@/global";
import { mapState } from "vuex";
export default {
  computed: mapState("pedidos", ["novopedido"]),
  data: () => ({
    dialog: false,
    headers: [
      { text: "Tipo embalagem", value: "tipoemb" },
      { text: "Valor", value: "valor", align: "end" },
    ],
  }),
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>